"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventRouter = exports.EventSourceBase = void 0;
var foundation_1 = require("@deqo/foundation");
/**
 * Provides a base implementation of StreamSource.
 */
var EventSourceBase = /** @class */ (function (_super) {
    __extends(EventSourceBase, _super);
    function EventSourceBase() {
        var _this = _super.call(this) || this;
        _this.buckets = {};
        _this.burden(function () { return _this.offAll(); });
        return _this;
    }
    EventSourceBase.prototype.on = function (type, sink) {
        var _this = this;
        this.guardDestroyed();
        var bu = this.buckets[type] || (this.buckets[type] = []);
        bu.push(sink);
        return function () { return _this.off(type, sink); };
    };
    EventSourceBase.prototype.once = function (type, to) {
        var off = this.on(type, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            off();
            to.apply(void 0, __spreadArray([], __read(args), false));
        });
        return off;
    };
    EventSourceBase.prototype.off = function (type, sink) {
        if (this.destroyed())
            return;
        if (sink) {
            var bu = this.buckets[type];
            if (bu) {
                var i = bu.indexOf(sink);
                if (i >= 0)
                    bu.splice(i, 1);
            }
        }
        else {
            delete this.buckets[type];
        }
    };
    EventSourceBase.prototype.offAll = function () {
        this.buckets = {};
    };
    EventSourceBase.prototype.emit = function (type, data) {
        if (this.destroyed())
            return;
        var dp = this.buckets[type];
        if (dp) {
            dp.forEach(function (x) { return x(data, type); });
        }
        var wp = this.buckets['*'];
        if (wp) {
            wp.forEach(function (x) { return x(data, type); });
        }
    };
    EventSourceBase.prototype.createAsRouter = function () {
        var e_1, _a, e_2, _b;
        var router = new EventRouter();
        try {
            for (var _c = __values(Object.keys(this.buckets)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var type = _d.value;
                try {
                    for (var _e = (e_2 = void 0, __values(this.buckets[type])), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var sink = _f.value;
                        router.on(type, sink);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return router;
    };
    EventSourceBase.prototype.createEventInput = function () {
        return { emit: this.emit.bind(this) };
    };
    return EventSourceBase;
}(foundation_1.AbstractDestroyable));
exports.EventSourceBase = EventSourceBase;
/**
 * Externally usable implementation of EventSource.
 */
var EventRouter = /** @class */ (function (_super) {
    __extends(EventRouter, _super);
    function EventRouter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * emits the specified event, notifying all subscribed sinks.
     *
     * @param type the data type.
     * @param data the data.
     */
    EventRouter.prototype.emit = function (type, data) {
        _super.prototype.emit.call(this, type, data);
    };
    /**
     * Resets the router to initial state by removing all subscribed sinks.
     */
    EventRouter.prototype.reset = function () {
        this.offAll();
    };
    return EventRouter;
}(EventSourceBase));
exports.EventRouter = EventRouter;
